/**
 * AppSidebar - desktop sidebar for client app
 */
import { NavLink } from "react-router-dom";
import {
    LayoutDashboard,
    Share2,
    FileEdit,
    CalendarDays,
    Megaphone,
    BarChart3,
    Crown,
    Settings,
    LifeBuoy,
    LogOut,
    Store,
} from "lucide-react";
import { LOGO_URL } from "@/lib/brand";
import { useAuth } from "@/lib/auth";
import { Link, useNavigate } from "react-router-dom";

const MENU = [
    { to: "/painel", label: "Painel de controlo", icon: LayoutDashboard, testid: "sidebar-dashboard-link" },
    { to: "/canais", label: "Meus Canais", icon: Share2, testid: "sidebar-channels-link" },
    { to: "/publicacoes", label: "Publicações", icon: FileEdit, testid: "sidebar-posts-link" },
    { to: "/calendario", label: "Calendário de Post", icon: CalendarDays, testid: "sidebar-calendar-link" },
    { to: "/campanhas", label: "Campanhas e Anúncios Ads", icon: Megaphone, testid: "sidebar-campaigns-link" },
    { to: "/publicidade", label: "Marketplace MeSafa", icon: Store, testid: "sidebar-ads-link" },
    { to: "/relatorios", label: "Relatórios", icon: BarChart3, testid: "sidebar-reports-link" },
    { to: "/subscricao", label: "Planos e Subscrição", icon: Crown, testid: "sidebar-subscription-link" },
    { to: "/configuracoes", label: "Configurações", icon: Settings, testid: "sidebar-settings-link" },
    { to: "/suporte", label: "Suporte", icon: LifeBuoy, testid: "sidebar-support-link" },
];

export default function AppSidebar() {
    const { user, logout } = useAuth();
    const nav = useNavigate();

    return (
        <aside
            className="hidden lg:flex w-[280px] shrink-0 sticky top-0 h-dvh flex-col border-r border-border bg-card/40 backdrop-blur-md"
            data-testid="app-sidebar"
        >
            <Link to="/painel" className="flex items-center gap-2 px-5 h-16 border-b border-border" data-testid="sidebar-logo">
                <span className="inline-flex h-9 w-9 items-center justify-center rounded-xl bg-[#0B0B10] overflow-hidden">
                    <img src={LOGO_URL} alt="MeSafa" className="h-9 w-9 object-contain" />
                </span>
                <span className="font-display font-bold text-lg tracking-tight">
                    <span className="text-[#A78BFA]">me</span>
                    <span>Safa</span>
                </span>
            </Link>

            <nav className="flex-1 overflow-y-auto scrollbar-thin py-4 px-3 space-y-1">
                {MENU.map((it) => {
                    const Icon = it.icon;
                    return (
                        <NavLink
                            key={it.to}
                            to={it.to}
                            className={({ isActive }) =>
                                `flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium ${
                                    isActive
                                        ? "sidebar-active text-foreground"
                                        : "text-muted-foreground hover:text-foreground hover:bg-white/5"
                                }`
                            }
                            data-testid={it.testid}
                        >
                            <Icon className="h-4 w-4" />
                            <span>{it.label}</span>
                        </NavLink>
                    );
                })}
            </nav>

            <div className="border-t border-border p-3">
                <div className="flex items-center gap-3 px-2 py-2">
                    <div className="h-9 w-9 rounded-full bg-gradient-to-br from-[#6B21D9] to-[#A78BFA] grid place-items-center text-white font-semibold">
                        {(user?.name || "M").slice(0, 1)}
                    </div>
                    <div className="flex-1 min-w-0">
                        <div className="text-sm font-medium truncate">{user?.name}</div>
                        <div className="text-xs text-muted-foreground truncate">{user?.company || user?.email}</div>
                    </div>
                    <button
                        onClick={() => {
                            logout();
                            nav("/");
                        }}
                        className="p-2 rounded-lg hover:bg-white/5 text-muted-foreground hover:text-foreground"
                        title="Sair"
                        data-testid="sidebar-logout-button"
                    >
                        <LogOut className="h-4 w-4" />
                    </button>
                </div>
            </div>
        </aside>
    );
}
